// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3S1H5","content":"styles_content__hPuzi","selectAll":"styles_selectAll__NHMY2"};